export default __webpack_public_path__ + "static/media/map_item_chosen.a88a3270.svg";